// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"c13fb9b2","120":"96b1bb75","405":"280b6b5a","476":"60975e82","720":"c97544b4","826":"d30e022b","893":"05b30af3"}[chunkId] + ".css";
};